/**
 * 3D全景接口
 */
import request from '../request'

const URL = {
  findPagePartIsFine: '/hotNews/findPagePartIsFine', // 资讯头新闻
  findNewsType: '/hotNews/findNewsType', // 资讯标题分类
  findPagePart: '/hotNews/findPagePart', // 分类新闻列表
  findById: '/hotNews/findById/', // 新闻详情
}

const news = {
  /**
  * 资讯头新闻
  * @param {object} reqData  请求参数
  */
  findPagePartIsFine (reqData) {
    return request.put(URL.findPagePartIsFine, reqData)
  },
  // 分类新闻列表
  findPagePart (reqData) {
    return request.put(URL.findPagePart, reqData)
  },

  // 资讯标题分类
  findNewsType () {
    return request.get(`${URL.findNewsType}?_dt=${new Date().getTime()}`)
  },

  // 新闻详情
  findById (id) {
    return request.get(`${URL.findById}/${id}?_dt=${new Date().getTime()}`)
  },
}
export default news
